<template>
  <div>
    <div
      ref="filesWrapper"
      class="c-chat__mediaFilesImages">
      <div
        v-for="message in messages"
        :key="message.id"
        class="c-chat__mediaFilesImageItem o-flex -alignCenter -center -fullHeight -column">
        <a
          :href="message.content"
          download
          target="_blank"
          rel="noopener noreferrer"
          class="o-flex -alignCenter -center -fullHeight">
          <span class="s-display-none">{{ message.content }}</span>
          <SvgIcon
            :type="icon(message.metadata?.file_type)"
            huge />
        </a>
        <div
          v-if="message.metadata?.file_name"
          class="t-caption1 t-clamp3 t-breakWords u-marginRight1 u-marginLeft1 u-marginBottom1">{{ message.metadata?.file_name }}</div>
      </div>
    </div>
    <div
      v-if="chatAttachmentsStore.loadingMessages"
      class="o-flex -alignCenter -center">
      <LoadingSpinner />
    </div>
    <div
      v-if="!chatAttachmentsStore.loadingMessages && messages.length === 0"
      class="o-flex -alignCenter -center t-alignCenter u-colorDark">
      <div>
        <div class="t-h6 u-marginBottom1">{{ $t('chat.media_empty_title') }}</div>
        <div class="t-caption2">{{ $t('chat.media_empty_description') }}</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onBeforeUnmount, onMounted, ref } from 'vue'

import LoadingSpinner from '@/components/LoadingSpinner.vue'
import constants from '@/constants'
import { useChatAttachmentsStore } from '@/modules/chat/chatAttachmentsStore'
import { useChatStore } from '@/modules/chat/chatStore'

const chatStore = useChatStore()
const chatAttachmentsStore = useChatAttachmentsStore(chatStore.chatThread.azure_chat_thread_id)

const messages = ref([])
const filesWrapper = ref(null)
const hasMore = ref(true)
const page = ref(1)
const totalCount = ref(0)

const loadMessages = async () => {
  try {
    const { data, total } = await chatAttachmentsStore.getMessagesByType(constants.CHAT.MESSAGE_TYPES.FILES, page.value)
    messages.value.push(...data)
    totalCount.value = total
  } catch (e) {
    console.error('Failed to load files:', e)
  } finally {
    hasMore.value = messages.value.length < totalCount.value
  }
}

const icon = (fileType) => {
  const icons = {
    [constants.LEARNINGMATERIALS.TYPE_VIDEO]: 'video',
    [constants.LEARNINGMATERIALS.TYPE_AUDIO]: 'audio',
    [constants.LEARNINGMATERIALS.TYPE_DOCUMENT]: 'unknown',
    [constants.LEARNINGMATERIALS.TYPE_DOCUMENT_WORD]: 'text-document',
    [constants.LEARNINGMATERIALS.TYPE_DOCUMENT_IMAGE]: 'image',
    [constants.LEARNINGMATERIALS.TYPE_DOCUMENT_PDF]: 'pdf',
    [constants.LEARNINGMATERIALS.TYPE_DOCUMENT_POWERPOINT]: 'presentation',
    [constants.LEARNINGMATERIALS.TYPE_DOCUMENT_SHEET]: 'sheet',
    [constants.LEARNINGMATERIALS.TYPE_ZIP]: 'zip',
  }
  return `filetype_${icons[fileType]}`
}

const onScroll = async (e) => {
  const t = e.target
  if (hasMore.value && !chatAttachmentsStore.loadingMessages && t.scrollHeight - t.scrollTop <= t.clientHeight + 50) {
    page.value++
    await loadMessages()
  }
}

loadMessages()

onMounted(() => {
  filesWrapper.value.addEventListener('scroll', onScroll)
})

onBeforeUnmount(() => {
  filesWrapper.value.removeEventListener('scroll', onScroll)
})

</script>

<style scoped>
.s-display-none {
  display: none;
}
</style>
